module.exports = __webpack_public_path__ + "static/media/14-vert.7c21d9a1.mp3";